import { render } from "./Franchise.vue?vue&type=template&id=42024622"
import script from "./Franchise.vue?vue&type=script&lang=js"
export * from "./Franchise.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Evuri\\New Owners\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__